import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
  LabelList,
  Cell,
  Text,
} from "recharts";
import { useSelector } from "react-redux";
import { Spin } from "antd";
import { Tooltip as Tooltip2 } from "@mui/material";
import VizHeader from "../VizHeader/VizHeader";
import { Dropdown } from "antd";
import FileSaver, { saveAs } from "file-saver";
import * as htmlToImage from "html-to-image";
import { useCurrentPng } from "recharts-to-png";

export default function BarComponent(props) {
  const expertOverview = useSelector((state) => state.expertOverviewCmReducer);
  const seekerOverview = useSelector((state) => state.seekerAwards);
  // const submittedData=
  const searchedValue = seekerOverview?.seekerAnalytics.slice(0, 25);
  const submittedValue = seekerOverview?.seekerSubmitted.slice(0, 25);

  // const data = expertOverview.expertAnalyticsData;

  const tickFormatter = (value) => {
    const limit = 10;
    if (value.length <= limit) return value;
    return `${value.substring(0, limit)}...`;
  };
  const [loading, setLoading] = useState(false);
  const [getPieChartPng, { ref: viewedRef }] = useCurrentPng();

  const items = [
    {
      key: "1",
      label: (
        // <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
        //   1st menu item
        // </a>
        <div onClick={() => handleAreaDownload()}>Download as PNG Image</div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={() => downloadSvgAsJpeg()}>Download as JPEG Image</div>
      ),
    },
    {
      key: "4",
      label: (
        <div onClick={() => handleDownloadSVG()}>Download SVG Vector image</div>
      ),
    },
  ];

  // const handleAreaDownload = React.useCallback(async () => {
  //   const png = await getPieChartPng();
  //   if (png) {
  //     FileSaver.saveAs(png, "answers-viewed.png");
  //   }
  // }, [getPieChartPng]);

  const handleAreaDownload = () => {
    htmlToImage
      .toJpeg(
        document.getElementsByClassName("recharts-wrapper")[1],
        { quality: 0.8, backgroundColor: "#fff" },
        { backgroundColor: "#fff" }
      )
      .then(function (dataUrl) {
        var link = document.createElement("a");
        link.download = `answers-viewed-top-20.png`;
        link.href = dataUrl;
        link.click();
      });
  };

  function downloadSvgAsJpeg() {
    htmlToImage
      .toJpeg(
        document.getElementsByClassName("recharts-wrapper")[1],
        { quality: 0.8, backgroundColor: "#fff" },
        { backgroundColor: "#fff" }
      )
      .then(function (dataUrl) {
        var link = document.createElement("a");
        link.download = "answers-viewed-top-20.jpeg";
        link.href = dataUrl;
        link.click();
      });
  }
  const handleDownloadSVG = () => {
    const chartContainer =
      document.getElementsByClassName("recharts-wrapper")[1];
    const chartSvg = chartContainer.querySelector("svg");
    const chartXml = new XMLSerializer().serializeToString(chartSvg);
    const svgBlob = new Blob([chartXml], {
      type: "image/svg+xml;charset=utf-8",
    });
    saveAs(svgBlob, "answers-viewed-top-20.svg");
  };

  useEffect(() => {
    // setLoading(true)
    // if(data !== null)
    // {
    //   setLoading(false)
    // }
  }, []);

  const truncate = (str, max = 8) => {
    if (!str) return "";
    return str.length > max ? str.substring(0, max) + "…" : str;
  };
  const CustomTick = ({ x, y, payload }) => {
    const fullName = payload?.value || "";
    const parts = fullName.split(" ");
    const first = parts[0] || "";
    const last = parts.slice(1).join(" "); // supports middle names too

    // value shown in the axis (first line + second line)
    const displayValue = last ? `${first}\n${last}` : first;
    console.log(displayValue);
    return (
      <Tooltip2 title={fullName} placement="top">
        <g transform={`translate(${x},${y})`}>
          <Text
            x={0}
            y={0}
            textAnchor="end"
            verticalAnchor="start"
            angle={-35} // slanted
            fontSize={11}
          >
            {truncate(fullName, 16)}
          </Text>
        </g>
      </Tooltip2>
    );
  };
  const CustomizedTooltipForViews = ({ active, payload, label }) => {
    if (active && payload && payload.length > 0 && payload[0].value > 0) {
      return (
        <>
          <p
            className="custom-tooltip"
            style={{
              padding: "5px",
              backgroundColor: "#fff",
              border: "1px solid #ececec",
            }}
          >
            {payload.map((obj, ind) => {
              return (
                <>
                  <p className="label">{obj.payload.name}</p>
                  <p
                    className="label"
                    style={{ color: obj.fill, textTransform: "capitalize" }}
                  >
                    {obj.dataKey}: {obj.value.toLocaleString()}
                  </p>
                </>
              );
            })}
          </p>
        </>
      );
    }
  };
  return (
    <>
      {props.name === "Questions Answered" && (
        <ResponsiveContainer width="100%" height={420}>
          <BarChart
            width={600}
            height={420}
            // data={data}
            margin={{
              top: 25,
              right: 30,
              left: 20,
              bottom: 33,
            }}
            barSize={20}
          >
            <XAxis
              tickFormatter={tickFormatter}
              fontSize={12}
              dataKey="name"
              interval={0}
              angle={-45}
              dy={18}
              minTickGap={-200}
            />
            <YAxis
              fontSize={12}
              dataKey="answers"
              tickFormatter={(value) =>
                new Intl.NumberFormat("en-US", {
                  notation: "compact",
                  compactDisplay: "short",
                }).format(value)
              }
              label={{
                value: "Answers",
                angle: -90,
                position: "insideLeft",
                fontWeight: "bold",
              }}
            />
            <Tooltip wrapperStyle={{ fontWeight: "bold", fontSize: "12px" }} />
            {/* <Legend fontSize={12} /> */}
            <CartesianGrid stroke="#ececec" vertical={false} />
            <Bar
              dataKey="answers"
              fill="rgb(124,181,236)"
              background={{ fill: "none" }}
            >
              {/* <LabelList fontSize={12} dataKey='answers' position="top" /> */}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}

      {props.name === "Answers Viewed" && (
        <>
          <div style={{ display: "flex", paddingTop: "5px", width: "100%" }}>
            <div style={{ width: "30%" }}></div>
            <div style={{ width: "40%" }}>
              <VizHeader type={4} isBold={true}>
                Answers Viewed - Top 20
              </VizHeader>
            </div>
            <div
              style={{
                width: "30%",
                paddingRight: "5px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <div>
                <Dropdown
                  menu={{
                    items,
                  }}
                >
                  <a onClick={(e) => e.preventDefault()}>
                    <i
                      className="fa fa-ellipsis-h"
                      style={{
                        fontSize: "20px",
                        color: "lightgray",
                        padding: "5px",
                      }}
                    ></i>
                  </a>
                </Dropdown>
              </div>
            </div>
          </div>
          <Spin spinning={loading}>
            <ResponsiveContainer width={"100%"} height={420}>
              <BarChart
                width={600}
                height={420}
                data={expertOverview.expertAnalyticsData}
                margin={{
                  top: 10,
                  right: 30,
                  left: 20,
                  bottom: 40,
                }}
                barSize={20}
                ref={viewedRef}
              >
                <XAxis
                  tick={<CustomTick />}
                  fontSize={12}
                  dataKey="name"
                  interval={0}
                  angle={-45}
                  dy={18}
                  minTickGap={-200}
                  height={40}
                />
                <YAxis
                  axisLine={false}
                  tickLine={false}
                  fontSize={12}
                  dataKey="views"
                  tickFormatter={(value) =>
                    new Intl.NumberFormat("en-US", {
                      notation: "compact",
                      compactDisplay: "short",
                    }).format(value)
                  }
                  label={{
                    value: "Views",
                    angle: -90,
                    position: "insideLeft",
                    fontWeight: "bold",
                  }}
                ></YAxis>
                <Tooltip
                  wrapperStyle={{ fontWeight: "bold", fontSize: "12px" }}
                  content={<CustomizedTooltipForViews />}
                />
                {/* <Legend fontSize={12} /> */}
                <CartesianGrid stroke="#ececec" vertical={false} />
                <Bar
                  dataKey={
                    props.name === "Questions Answered"
                      ? "answers"
                      : props.name === "Answers Viewed"
                      ? "views"
                      : ""
                  }
                  fill="#009bff"
                  background={{ fill: "none" }}
                >
                  {/* <LabelList fontSize={12} dataKey='views' position="top" /> */}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </Spin>
        </>
      )}
      {props.name === "Ratings" && (
        <>
          <BarChart
            data={props.data}
            width={240}
            height={400}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
            stackOffset="expand"
            barSize={30}
          >
            <Cell style={{ outline: "none" }} />
            <XAxis
              minTickGap={300}
              margin={{ top: 5, right: 30, left: 55, bottom: 20 }}
              interval={0}
              dataKey="name"
              style={{ fontSize: "14px" }}
            ></XAxis>
            <YAxis
              minTickGap={-100}
              style={{ fontSize: "14px" }}
              allowDecimals={false}
            ></YAxis>
            <Tooltip
              wrapperStyle={{
                fontFamily: "inherit",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            />
            <Bar
              dataKey="value"
              fill="rgb(255, 220, 0)"
              label={{
                position: "top",
                fontWeight: "bold",
                fontSize: "14px",
                fontFamily: "inherit",
              }}
            />
          </BarChart>
        </>
      )}
    </>
  );
}
